import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var InvPlusLogoIcon = function InvPlusLogoIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 158.07 34.78' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '110px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox,
      width: width,
      height: height
    },
    /*#__PURE__*/
    React.createElement("title", null, "Asset 3"),
    /*#__PURE__*/
    React.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    },
    /*#__PURE__*/
    React.createElement("polygon", {
      className: classes.cls1,
      points: "40.82 12 43.3 12 43.3 22.8 40.82 22.8 40.82 25.2 48.37 25.2 48.37 22.8 45.88 22.8 45.88 12 48.37 12 48.37 9.6 40.82 9.6 40.82 12"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M59.53,13.87a4.11,4.11,0,0,0-2.48-.66,4.35,4.35,0,0,0-2.3.64,5.23,5.23,0,0,0-1.39,1.22V13.45H50.9V25.2h2.46V18.11a2.39,2.39,0,0,1,.38-1.31,2.91,2.91,0,0,1,1-1,3.13,3.13,0,0,1,1.52-.36,2.13,2.13,0,0,1,1.41.29,1.82,1.82,0,0,1,.71,1,4.45,4.45,0,0,1,.22,1.47v7h2.47V18.06a8.1,8.1,0,0,0-.35-2.43A3.44,3.44,0,0,0,59.53,13.87Z"
    }),
    /*#__PURE__*/
    React.createElement("polygon", {
      className: classes.cls1,
      points: "68.25 21.54 64.97 13.52 64.94 13.45 62.28 13.45 67.25 25.2 69.01 25.2 74.23 13.45 71.67 13.45 68.25 21.54"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M83,13.92a5.14,5.14,0,0,0-2.7-.73,6.07,6.07,0,0,0-3,.75,5.65,5.65,0,0,0-2.19,2.15,6.51,6.51,0,0,0-.83,3.36,6,6,0,0,0,.78,3.07,5.58,5.58,0,0,0,2.18,2.13,7,7,0,0,0,7.78-1h.17L84,21.79l-.08.07a10.07,10.07,0,0,1-1.22.86,3.68,3.68,0,0,1-1.91.43,4.05,4.05,0,0,1-2.69-.88A3.57,3.57,0,0,1,76.83,20h8.83l0-1.07a6,6,0,0,0-.72-3A5.35,5.35,0,0,0,83,13.92Zm-6.11,4a2.87,2.87,0,0,1,1.2-1.89,4.12,4.12,0,0,1,2.21-.59,2.85,2.85,0,0,1,1.32.31,2.77,2.77,0,0,1,1,.86,2.35,2.35,0,0,1,.48,1.26V18Z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M96.13,13.87a4.06,4.06,0,0,0-2.48-.66,4.32,4.32,0,0,0-2.29.64A5.23,5.23,0,0,0,90,15.07V13.45H87.5V25.2H90V18.11a2.39,2.39,0,0,1,.38-1.31,2.75,2.75,0,0,1,1-1,3.13,3.13,0,0,1,1.52-.36,2.13,2.13,0,0,1,1.41.29,1.93,1.93,0,0,1,.71,1,4.45,4.45,0,0,1,.22,1.47v7h2.46V18.06a8.11,8.11,0,0,0-.34-2.43A3.45,3.45,0,0,0,96.13,13.87Z"
    }),
    /*#__PURE__*/
    React.createElement("polygon", {
      className: classes.cls1,
      points: "104.05 10.51 101.58 10.51 101.58 13.45 99.19 13.45 99.19 15.85 101.58 15.85 101.58 25.2 104.05 25.2 104.05 15.85 106.73 15.85 106.73 13.45 104.05 13.45 104.05 10.51"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M116.37,14a5.92,5.92,0,0,0-3-.78,6,6,0,0,0-3,.78,5.89,5.89,0,0,0-2.16,2.16,6.24,6.24,0,0,0-.79,3.17,6.2,6.2,0,0,0,.79,3.16,5.89,5.89,0,0,0,2.16,2.16,6,6,0,0,0,3,.78,5.92,5.92,0,0,0,3-.78,5.79,5.79,0,0,0,2.15-2.16,6.21,6.21,0,0,0,.8-3.16,6.25,6.25,0,0,0-.8-3.17A5.79,5.79,0,0,0,116.37,14Zm.44,5.33h0a4.16,4.16,0,0,1-.44,2,3.54,3.54,0,0,1-1.25,1.35,3.48,3.48,0,0,1-3.56,0,3.42,3.42,0,0,1-1.26-1.35,3.94,3.94,0,0,1-.44-2,4,4,0,0,1,.44-2A3.35,3.35,0,0,1,111.56,16a3.54,3.54,0,0,1,3.56,0,3.47,3.47,0,0,1,1.25,1.35A4.17,4.17,0,0,1,116.81,19.32Z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M127.05,13.21a3.71,3.71,0,0,0-2.12.7,4.37,4.37,0,0,0-1.3,1.41V13.45h-2.49V25.2h2.49V18.72a2.78,2.78,0,0,1,.43-1.54,3.1,3.1,0,0,1,1.1-1,2.88,2.88,0,0,1,1.34-.35,2.82,2.82,0,0,1,.65.08,2,2,0,0,1,.51.17l.12.06.64-2.66-.07,0A3.06,3.06,0,0,0,127.05,13.21Z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M136.28,21.85c-.05.15-.11.3-.16.46a1.72,1.72,0,0,0-.07.21l-.06-.18a1.81,1.81,0,0,0-.14-.33l-3.6-8.5,0-.06h-2.86l5.41,12.23-2,4.58h2.66l2-5.12,4.75-11.55.05-.14h-2.9Z"
    }),
    /*#__PURE__*/
    React.createElement("polygon", {
      className: classes.cls1,
      points: "149.48 13.45 146.97 13.45 146.97 17.85 142.63 17.85 142.63 20.03 146.97 20.03 146.97 24.28 149.48 24.28 149.48 20.03 153.86 20.03 153.86 17.85 149.48 17.85 149.48 13.45"
    }),
    /*#__PURE__*/
    React.createElement("polygon", {
      className: classes.cls1,
      points: "153.82 10.69 154.4 10.69 154.4 12.38 154.86 12.38 154.86 10.69 155.47 10.69 155.47 10.24 153.82 10.24 153.82 10.69"
    }),
    /*#__PURE__*/
    React.createElement("polygon", {
      className: classes.cls1,
      points: "157.62 10.24 156.91 11.44 156.19 10.24 155.78 10.24 155.78 12.38 156.26 12.38 156.26 11.17 156.7 11.92 157.1 11.92 157.57 11.1 157.57 12.38 158.07 12.38 158.07 10.24 157.62 10.24"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls2,
      d: "M29.69,5.09a17.39,17.39,0,1,1-24.6,0,17.4,17.4,0,0,1,24.6,0"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls3,
      d: "M18.49,8.62l1.28,5.55a1.15,1.15,0,0,0,.85.84l5.54,1.29a1.12,1.12,0,0,1,0,2.19l-5.54,1.28a1.15,1.15,0,0,0-.85.85l-1.28,5.54a1.12,1.12,0,0,1-2.19,0L15,20.62a1.15,1.15,0,0,0-.84-.85L8.62,18.49a1.12,1.12,0,0,1,0-2.19L14.17,15a1.16,1.16,0,0,0,.84-.84L16.3,8.62a1.12,1.12,0,0,1,2.19,0"
    }))))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.common.mediumGray
      };
    },
    cls2: {
      fill: theme.palette.product.inventoryPlus
    },
    cls3: {
      fill: theme.palette.common.white,
      fillRule: 'evenodd'
    }
  };
});